import { render } from "./UsersTableItems.vue?vue&type=template&id=29450872"
import script from "./UsersTableItems.vue?vue&type=script&lang=js"
export * from "./UsersTableItems.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__